var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckVerde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F5BF30D6-37A6-4949-88F8-5291F15946E0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ficha-del-Proyecto--|-modo-edici\\xF3n-activado",
    transform: "translate(-607.000000, -1377.000000)",
    fill: "#1FA406",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(588.000000, 1314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(19.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simbol/check-verde",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33296,5.94864 L3.3048,6.9768 L6.6096,10.2816 L13.9536,2.9376 L12.92544,1.90944 L6.6096,8.22528 L4.33296,5.94864 Z M13.2192,7.344 C13.2192,10.57536 10.57536,13.2192 7.344,13.2192 C4.11264,13.2192 1.4688,10.57536 1.4688,7.344 C1.4688,4.11264 4.11264,1.4688 7.344,1.4688 C7.93152,1.4688 8.4456,1.54224 8.95968,1.68912 L10.1347488,0.51408 C9.25344,0.22032 8.29872,5.06261699e-14 7.344,5.06261699e-14 C3.3048,5.06261699e-14 9.60120872e-13,3.3048 9.60120872e-13,7.344 C9.60120872e-13,11.3832 3.3048,14.688 7.344,14.688 C11.3832,14.688 14.688,11.3832 14.688,7.344 L13.2192,7.344 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerde);
export default __webpack_public_path__ + "static/media/check-verde.c4964335.svg";
export { ForwardRef as ReactComponent };